import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Toast, { POSITION } from 'vue-toastification';
import naive from 'naive-ui';
import 'vue-toastification/dist/index.css'; // 導入預設 CSS
import 'sweetalert2/dist/sweetalert2.min.css';

// Confirmation controls stay Chinese regardless of the browser's preferred language.
document.documentElement.lang = 'zh-TW';

const app = createApp(App);
const options = {
    position: POSITION.TOP_RIGHT, // 預設位置
    timeout: 3000, // 預設持續時間 (3秒)
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false
};

app.use(Toast, options);
app.use(naive)
app.use(router).mount('#app')
